import React, { useEffect, useState } from 'react';
import { SearchInput } from '@eika/input';
import classNames from 'classnames';
import ErrorMessage from './question/errormessage';

const DropDown = ({
    selected,
    values,
    disabled,
    placeholder,
    label,
    extraMarginBottom,
    onBlur,
    removeValue,
    selectValue,
    errorText,
    customDropDownWidthClass,
}) => {
    const selectedValue = values.find((value) => value.value === selected);
    const [searchString, setSearchString] = useState(selectedValue?.text ?? '');
    const [inputInFocus, setInputInFocus] = useState(false);
    const [timeoutObject, setTimeoutObject] = useState();

    useEffect(() => {
        return () => clearTimeout(timeoutObject);
    }, [timeoutObject]);

    useEffect(() => {
        if (selectedValue?.text) {
            setSearchString(selectedValue?.text ?? '');
        }
    }, [selectedValue]);

    const filteredList = values.filter((value) => {
        return searchString ? value.text.toLowerCase().startsWith(searchString.toLowerCase()) : true;
    });

    return (
        <div className="custom-drop-down-container">
            {disabled ? (
                <>
                    {label && <h2 className="skjema-input-question">{label}</h2>}
                    <span>{selectedValue.text}</span>
                </>
            ) : (
                <>
                    {label && (
                        <h2
                            className={classNames('skjema-input-question', {
                                'margin-bottom-medium': extraMarginBottom,
                            })}
                        >
                            {label}
                        </h2>
                    )}
                    <SearchInput
                        placeholder={placeholder}
                        value={searchString}
                        onChange={(event) => {
                            const { value } = event.target;
                            if (
                                filteredList?.length < 1 ||
                                value === '' ||
                                value?.length < selectedValue?.text?.length
                            ) {
                                removeValue();
                                setInputInFocus(true);
                            }
                            setSearchString(value);
                        }}
                        className="custom-drop-down-search-input"
                        onFocus={() => setInputInFocus(true)}
                        onBlur={() => {
                            setTimeoutObject(
                                setTimeout(() => {
                                    if (onBlur !== undefined) {
                                        onBlur();
                                    }
                                    setInputInFocus(false);
                                }, 200)
                            );
                        }}
                    />
                    {inputInFocus && !selectedValue && (
                        <ul className={classNames('custom-searchable-select', customDropDownWidthClass)}>
                            {filteredList.map((value) => {
                                return (
                                    <li key={`select-element-${value.value}`}>
                                        <span
                                            key={value.value}
                                            onClick={() => {
                                                selectValue(value.value);
                                                setInputInFocus(false);
                                            }}
                                            onKeyPress={() => {
                                                selectValue(value.value);
                                                setInputInFocus(false);
                                            }}
                                        >
                                            {value.text}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                    {errorText && <ErrorMessage text={errorText} />}
                </>
            )}
        </div>
    );
};

export default DropDown;
